import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { IconButton, Badge } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SelectStatus from './SelectStatus';
import { patchOrder, patchOrderStatus } from '../api/Api';


export default function QueuedOrders(props) {
    const [open, setOpen] = React.useState(false);
    const [firstOpen, setFirstOpen] = React.useState(true);
    const [order, setOrder] = React.useState(props.order);
    const [loadingOrder, setLoadingOrder] = React.useState(false);

    var createdAt = new Date(order.creationDate);


    const onChangePizzaStatus = (pizzaCode, newStatus) => {
        const updatedOrder = {
            ...order,
            pizzas: order.pizzas.map(p =>
                p.pizzaCode === pizzaCode ? { ...p, status: newStatus } : p
            )
        };
        setOrder(updatedOrder);
        setLoadingOrder(true);
        // Prepare request body
        const orderData = {
            pizzas: updatedOrder.pizzas
        };
        patchOrder(orderData, order.orderCode)
            .then(result => {
                setLoadingOrder(false)
            })
            .catch(err => console.error("Error", err));
    };

    const onChangeOrderStatus = (code, newStatus) => {
        setOrder(prev => ({
            ...prev,
            status: newStatus
        }));

        // Prepare request body
        const orderStatusData = {
            status: newStatus
        };
        patchOrderStatus(code, orderStatusData)
            .then(result => {
                setLoadingOrder(false)
            })
            .catch(err => console.error("Error", err));

    };

    const openOnclick = (isOpen) => {
        setOpen(isOpen)
        if (isOpen) {
            setFirstOpen(false)
        }
    }

    const calculateOrderTotal = (pizzas) => {
        return pizzas.reduce((total, pizza) => {
            const subtotal = (pizza.price || 0) * (pizza.quantity || 0);
            return total + subtotal;
        }, 0);
    }
    const rowBgColor = props.rowIndex % 2 === 0 ? '#f5f5f5ff' : '#fff2d7';
    const rowSx = {
        '& > *': { borderBottom: 'unset' },
        backgroundColor: rowBgColor
    };

    const PizzaHeaders = () => (
        <TableHead sx={{
            '& .MuiTableCell-root': { color: '#fff2d7' },
            '& .MuiTableRow-root ': { backgroundColor: '#16314c' }
        }}>
            <TableRow key={"dishe_order_" + order.id}>
                <TableCell>{"Dishe"}</TableCell>
                <TableCell >{"Quantity"}</TableCell>
                <TableCell>{"Price"}</TableCell>
                <TableCell>{"Tot"}</TableCell>
                <TableCell>{"Action status"}</TableCell>
            </TableRow>
        </TableHead>
    );

    const PizzaRow = ({ pizza }) => (
        <TableRow key={pizza.pizzaCode} sx={{ height: 'auto' }}>
            <TableCell>{pizza.name}</TableCell>
            <TableCell>{pizza.quantity}</TableCell>
            <TableCell>{pizza.price.toFixed(2) + " €"}</TableCell>
            <TableCell>{(pizza.quantity * pizza.price).toFixed(2) + " €"}</TableCell>
            <TableCell>
                <SelectStatus
                    status={pizza.status}
                    code={pizza.pizzaCode}
                    onChangeStatus={onChangePizzaStatus}
                    disabled={loadingOrder}
                />
            </TableCell>
        </TableRow>
    );

    const OrderHeaders = ({ order }) => (
        <TableRow key={"infor_order_" + order.id} sx={rowSx}>
            <TableCell >
                <SelectStatus
                    code={order.orderCode}
                    status={order.status}
                    onChangeStatus={onChangeOrderStatus}
                    disabled={loadingOrder}
                />
            </TableCell>
            <TableCell>{order.customerName}</TableCell>
            <TableCell>
                {createdAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </TableCell>
            <TableCell>{order.orderCode}</TableCell>
            <TableCell>{calculateOrderTotal(order.pizzas) + " €"}</TableCell>
            <TableCell align="right">
                <Badge
                    variant="dot"
                    color="success"
                    invisible={!firstOpen}
                    overlap="circular"
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => openOnclick(!open)}
                        disabled={loadingOrder}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </Badge>
            </TableCell>
        </TableRow>
    );


    return (
        <React.Fragment>
            <OrderHeaders order={order} />
            <TableRow key={"value_info_order_" + order.id} sx={{ opacity: loadingOrder ? 0.5 : 1 }} >
                <TableCell style={{ padding: 0 }} colSpan={8}>
                    <Collapse in={open} timeout="auto" unmountOnExit style={{ padding: 0 }}>
                        <Box>
                            <Table size="small" aria-label="purchases" sx={{
                                width: '100%',
                                borderCollapse: 'collapse'
                            }}>
                                <PizzaHeaders />
                                <TableBody sx={rowSx}>
                                    {order.pizzas.map((pizza) => (
                                        <PizzaRow key={pizza.pizzaCode} pizza={pizza} />
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment >
    );
}
